import React, { createContext, useContext, useEffect, useReducer } from "react";
import {
  INITIAL_STATE,
  inventoryArticlesReducer,
  types,
} from "../../reducers/inventory/inventoryArticlesReducer";
import axios, { axiosClient } from "../../api/axios";
import { alertWarning, showTypeErrorFetch } from "../../utilities/alerts.utilities";

const InventoryArticlesByWarehouseContext = createContext({});
const InventoryArticlesByWarehouseProvider = ({ children }) => {

  const [state, dispatch] = useReducer(inventoryArticlesReducer, INITIAL_STATE);

  const { selected_warehouses } = state;
  const warehouseIds = selected_warehouses.map((w) => w.id).filter(Boolean);

  const setFieldWarehouse = (selectedOptions) => {
    dispatch({
      type: types.CHANGE_SELECT_WAREHOUSE,
      payload: Array.isArray(selectedOptions) ? selectedOptions : [],
    });
  };

  const setFieldArticle = (item_id, warehouse_id = null) => {
    dispatch({
      type: types.CHANGE_SELECT_ARTICLE,
      payload: { item_id, warehouse_id },
    });
  };

  const setWarehouseInventoryFilters = (patch) => {
    dispatch({
      type: types.CHANGE_WAREHOUSE_INVENTORY_FILTERS,
      payload: patch,
    });
  };

  useEffect(() => {
    if (warehouseIds.length > 0) {
      axios()
        .get("inventory/getArticlesStockByWarehouse", {
          params: { ...state.articles.filter, warehouse_ids: warehouseIds },
        })
        .then(({ data }) => {
          dispatch({
            type: types.ARTICLES_LOADED,
            payload: { elements: data.articles ?? [], rows: data.rows ?? 0 },
          });
        })
        .catch((e) => showTypeErrorFetch(e));
    }
  }, [
    state.articles.status,
    state.articles.filter.page,
    state.articles.filter.limit,
    state.articles.filter.name,
    state.articles.filter.reference,
    state.articles.filter.equivalent_measure_id,
    warehouseIds.join(","),
  ]);

  useEffect(() => {
    if (warehouseIds.length > 0) {
      axios()
        .get("inventory/getArticlesDetailStockByWarehouse", {
          params: { ...state.detail_articles.filter, warehouse_ids: warehouseIds },
        })
        .then(({ data }) => {
          dispatch({
            type: types.DETAIL_ARTICLES_LOADED,
            payload: { elements: data.articles ?? [], rows: data.rows ?? 0 },
          });
        })
        .catch((e) => showTypeErrorFetch(e));
    }
  }, [
    state.detail_articles.status,
    state.detail_articles.filter.page,
    state.detail_articles.filter.limit,
    state.detail_articles.filter.name,
    state.detail_articles.filter.reference,
    state.detail_articles.filter.equivalent_measure_id,
    warehouseIds.join(","),
  ]);

  const getTotalDetail = (details) => {
    const values = Object.values(details);
    return values.reduce(function (acc, obj) {
      return parseFloat(acc) + parseFloat(obj.stock);
    }, 0);
  };
  

  const getInventoryItemByLotesUpdated = ({
    item_id,
    warehouse_id,
    measure_name,
  }) => {

    axiosClient()
      .get(`inventory/getHasLoteArticleRec/${item_id}`)
      .then(( {data} ) => {
        if (data) {
          axiosClient()
          .get(`inventory/getInventoryItemByLotesUpdated/${item_id}/${warehouse_id}`)
          .then(({ data }) => {
            dispatch({
              type: types.LOAD_INVENTORY_LOTES_ITEM,
              payload: data,
            });
            dispatch({
              type: types.LOAD_INVENTORY_LOTES_ITEM_MEASURE_NAME,
              payload: measure_name,
            });
          })
          .catch((e) => {
            showTypeErrorFetch(e);
            
          })
        }
        else{
          alertWarning("Este articulo no maneja lotes.");
          dispatch({
            type: types.RELOAD_INVENTORY_LOTES_ITEM_INITIAL_STATE,
            payload: measure_name,
          });
        }
      })
      .catch((e) => {
        showTypeErrorFetch(e); 
      });
  };

    return (
        <InventoryArticlesByWarehouseContext.Provider
          value={[
            state,
            dispatch,
            {
              setFieldWarehouse,
              getInventoryItemByLotesUpdated,
              getTotalDetail,
              setFieldArticle,
              setWarehouseInventoryFilters,
            },
          ]}
        >
          {children}
        </InventoryArticlesByWarehouseContext.Provider>
      );
};

const useInventoryArticles = () => useContext(InventoryArticlesByWarehouseContext)[0];
const useDispatchInventoryArticles = () => useContext(InventoryArticlesByWarehouseContext)[1];
const useActionsInventoryArticles = () => useContext(InventoryArticlesByWarehouseContext)[2];

export {
  InventoryArticlesByWarehouseContext,
  useInventoryArticles,
  useDispatchInventoryArticles,
  useActionsInventoryArticles,
};
export default InventoryArticlesByWarehouseProvider;